import { useEffect } from "react";
import { toast } from "sonner";
import { applyHostMessage } from "@/lib/patchState";

export const webviewHost = () => window.chrome?.webview;

const showNotice = (p) => (p.level === "error" ? toast.error : toast.success)(p.message);

export function useHostMessages(isHost, post, setState, setFeatures) {
  useEffect(() => {
    if (!isHost) return undefined;
    const host = webviewHost();
    const onMsg = (e) => {
      const { type, payload } = e.data || {};
      if (type === "hello") setFeatures(payload.features || []);
      else if (type === "notice") showNotice(payload);
      else setState((s) => applyHostMessage(s, type, payload));
    };
    host.addEventListener("message", onMsg);
    post({ type: "ready" });
    return () => host.removeEventListener("message", onMsg);
  }, [isHost, post, setState, setFeatures]);
}
